export const PORTFOLIO_BETA_STRATEGY_CODE = 1017
export const PORTFOLIO_BETA_DISPLAY_LABEL =
  'FinRakshak - Portfolio Beta Hedging Advisory'

export const FINSAVER_DISPLAY_LABEL = 'FINSaver Advisory - Debt Advisory'

export const VERIFICATION_PRODUCTS = [
  {
    key: 'INDEX_LONG_TERM_STRATEGY',
    type: 'PRODUCT',
    label: 'Index long term strategy',
    strategyCode: null,
  },
  {
    key: 'FINRAKSHAK_PORTFOLIO_BETA',
    type: 'PRODUCT',
    label: PORTFOLIO_BETA_DISPLAY_LABEL,
    strategyCode: PORTFOLIO_BETA_STRATEGY_CODE,
  },
  {
    key: 'FINSAVER_DEBT_ADVISORY',
    type: 'PRODUCT',
    label: FINSAVER_DISPLAY_LABEL,
    strategyCode: null,
  },
]

export const STANDALONE_VERIFICATION_PRODUCTS = VERIFICATION_PRODUCTS

const findStandaloneProduct = (strategyCode) =>
  strategyCode === null || strategyCode === undefined
    ? null
    : STANDALONE_VERIFICATION_PRODUCTS.find(
      (product) =>
        product?.strategyCode !== null &&
        product?.strategyCode !== undefined &&
        String(product?.strategyCode || '') === String(strategyCode || ''),
    ) || null

const findPlanByStrategyCode = (plans = [], strategyCode) =>
  plans.find(
    (plan) =>
      String(plan?.strategyCode || '') === String(strategyCode || ''),
  ) || null

const normalizePlanName = (value = '') =>
  value.toString().replace(/[^a-z0-9]/gi, '').toLowerCase()

export const getStandaloneProductByStrategyCode = (strategyCode) =>
  findStandaloneProduct(strategyCode)

export const isPortfolioBetaProduct = (user = {}) =>
  String(user?.strategyCode || user?.plan?.strategyCode || '') ===
  String(PORTFOLIO_BETA_STRATEGY_CODE) ||
  normalizePlanName(user?.plan?.name) === 'finrakshak'

export const isFinsaverProduct = (user = {}) => {
  const name = normalizePlanName(user?.plan?.name)
  return (
    name.includes('finsaver') ||
    name.includes('conservative') ||
    name.includes('moderate') ||
    name.includes('aggressive')
  )
}

export const getInitialVerificationProductValue = (user = {}, plans = []) => {
  if (isPortfolioBetaProduct(user)) {
    return 'PRODUCT::FINRAKSHAK_PORTFOLIO_BETA'
  }

  if (isFinsaverProduct(user)) {
    return 'PRODUCT::FINSAVER_DEBT_ADVISORY'
  }
  const planId = user?.planId || user?.plan?.id

  if (planId || user?.strategyCode || user?.plan?.strategyCode) {
    return 'PRODUCT::INDEX_LONG_TERM_STRATEGY'
  }

  const planFromStrategyCode = findPlanByStrategyCode(plans, user?.strategyCode)

  if (planFromStrategyCode?.id) {
    return 'PRODUCT::INDEX_LONG_TERM_STRATEGY'
  }

  const selectedProduct = findStandaloneProduct(user?.strategyCode)

  if (selectedProduct) {
    return `PRODUCT::${selectedProduct.key}`
  }

  return undefined
}

export const parseVerificationProductValue = (value, plans = []) => {
  if (!value) return null

  const [type, rawValue] = value.split('::')

  if (type === 'ILTS_PLAN') {
    const plan = plans.find(
      (currentPlan) => String(currentPlan?.id || '') === String(rawValue || ''),
    )

    if (!plan) return null

    const normalizedPlanId = Number.parseInt(String(plan.id), 10)

    if (Number.isNaN(normalizedPlanId)) return null

    return {
      type,
      label: 'Index Long Term Strategy',
      planId: normalizedPlanId,
      planName: plan.name,
      strategyCode: plan.strategyCode || null,
    }
  }

  if (type === 'PRODUCT') {
    const product = STANDALONE_VERIFICATION_PRODUCTS.find(
      (currentProduct) => currentProduct.key === rawValue,
    )

    if (!product) return null

    return {
      ...product,
      planId: null,
      planName: null,
    }
  }

  return null
}

export const getVerificationProductSummary = (selectedProduct) => {
  if (!selectedProduct) {
    return {
      selectedProductLabel: '',
      selectedPlanLabel: '',
    }
  }

  return {
    selectedProductLabel:
      selectedProduct.label || 'Index long term strategy',
    selectedPlanLabel: '',
  }
}
